/**
 * Function to swap special characters like umlauts to normalized chars
 * https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
 */
// Added "" here as default as it was breaking when nothing provided. 
export function NormalizeSpecialChars(value: string = ""): string {
  const convertedString = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  return convertedString
}